// Add your custom JS here.

document.addEventListener("DOMContentLoaded", function () {
    const sr = ScrollReveal({
        duration: 2000,
        easing: "ease-in-out",
        reset: true,
    });

    // Animatie-instellingen voor verschillende klassen
    const animations = {
        ".sr-zoom-in": {
          scale: 0.65
        },
        ".sr-right": {
          distance: "100px",
          origin: "right"
        },
        ".sr-slide": {
          distance: "1000px",
          origin: "right",
          duration: 1000,
          easing: "cubic-bezier(0.5, 0, 0, 1)",
          viewOffset: { top: 80, right: 0, bottom: 80, left: 0 }
        },
    };

    // ScrollReveal toepassen op alle klassen
    Object.entries(animations).forEach(([selector, config]) => {
        sr.reveal(selector, config);
    });

    // Dynamische vertraging voor .sr-ballon (met data-sr-delay)
document.querySelectorAll(".sr-ballon").forEach((el) => {
    sr.reveal(el, {
        distance: "20px",
        origin: "top",
        opacity: 1,
        reset: false,
        delay: parseInt(el.dataset.srDelay) || 0, // Gebruik data-sr-delay of 0 als fallback
    });
});

    // Achtergrondafbeeldingen controleren bij paginalading
    document.querySelectorAll(".sr-zoom-in[data-bg-image]").forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight) {
            loadBackgroundImage(el);
        }
        observeBackgroundImage(el);
    });

    // Lazy-loaded afbeeldingen verwerken
    document.addEventListener("lazyloaded", function (e) {
        Object.entries(animations).forEach(([selector, config]) => {
            if (e.target.matches(selector)) {
                e.target.style.opacity = "";
                e.target.style.transform = "";

                sr.clean(e.target);
                sr.reveal(e.target, config);
            }
        });
    });

    // Functie om een achtergrondafbeelding te laden
    function loadBackgroundImage(el) {
        const bg = el.getAttribute('data-bg-image');
        if (bg && (!el.style.backgroundImage || el.style.backgroundImage === "inherit")) {
            el.style.backgroundImage = bg;
            el.classList.add('revealed');
        }
    }

    // Observer om te controleren of de achtergrondafbeelding wordt verwijderd
    function observeBackgroundImage(el) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "style") {
                    const bg = el.getAttribute('data-bg-image');
                    if (bg && (!el.style.backgroundImage || el.style.backgroundImage === "inherit")) {
                        el.style.backgroundImage = bg;
                    }
                }
            });
        });
        observer.observe(el, { attributes: true, attributeFilter: ["style"] });
    }
});



// ScrollReveal().reveal('.kies-hero-titel1', { distance: '-50px' })
// ScrollReveal().reveal('.kies-hero-subtitel', { distance: '-50px', delay: 1000 })
// ScrollReveal().reveal('.kies-hero-titel2', { distance: '-50px', delay: 1000 })
// ScrollReveal().reveal('.kies-hero-button', { distance: '-50px', delay: 2500 })
// ScrollReveal().reveal('.kies-sr-top', { distance: '50px', origin: 'top', interval: 300 })
// ScrollReveal().reveal('.kies-sr-button', { distance: '100px', origin: 'bottom', delay: 1000, duration: 2000, reset: false })

// ScrollReveal().reveal('.kies-sr-blok-1', { distance: '600px', origin: 'right', duration: 2000, rotate: { z: 90 }, interval: 300, reset: false })
